import { merge } from "lodash"
import Lists from "./list"
import { Backdrop } from "./backdrop"
import { Typography } from "./typography"
import { Autocomplete } from "./autocomplete"
import { IconButton } from "./icon-button"
import { Tooltip } from "./tooltip"
import { Button } from "./button"
import { Input } from "./input"
import { Paper } from "./paper"
import { Card } from "./card"
import { DataGrid } from "./datagrid"
import { TextField } from "./textfield"

export default function ComponentsOverrides(theme) {
  return merge(
    Card(theme),
    Lists(theme),
    Paper(theme),
    Input(theme),
    Button(theme),
    Tooltip(theme),
    Backdrop(theme),
    Typography(theme),
    IconButton(theme),
    Autocomplete(theme),
    DataGrid(theme),
    TextField(theme),
  )
}
